import * as Styled from './Highlighter.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const escapeRegExp = str => str.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
export function Highlighter({
  children,
  highlight,
  matchElement,
  caseSensitive = false
}) {
  const regExp = typeof highlight === 'string' ? new RegExp(escapeRegExp(highlight), `g${caseSensitive ? '' : 'i'}`) : highlight;
  const matches = children.match(regExp);
  return highlight === '' ? children : /*#__PURE__*/_jsx(_Fragment, {
    children: children.split(regExp).reduce((acc, str, i) => {
      acc.push(str);
      const match = matches == null ? void 0 : matches[i];
      if (match) {
        acc.push(match);
      }
      return acc;
    }, []).map((str, i) => regExp.test(str) ?
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _jsx(Styled.Mark, {
      as: matchElement,
      children: str
    }, `${str}${i}`) : str)
  });
}
export default Highlighter;